import React from 'react'
import { IconType } from 'react-icons'

import { TableCell, TableRow } from '@/components/ui/table'

interface Props {
  Icon: IconType
  title: string
  content: React.ReactNode
}

const SummaryTableRow: React.FC<Props> = ({ Icon, title, content }) => {
  return (
    <TableRow className="hover:bg-white">
      <TableCell className="bg-white">
        <div className="flex items-center font-bold">
          <Icon size={16} />
          <span className="text-dark ms-3 @max-sm:sr-only">{title}</span>
        </div>
      </TableCell>

      <TableCell>{content}</TableCell>
    </TableRow>
  )
}

export default SummaryTableRow
